if (!window.customElements.get('sale-image-swiper')) {
  customElements.define('sale-image-swiper', class extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.$section = null;
        this._checkSwiperInterval = null;
        this.resizeHandler = null;
        this.prevButton = null;
        this.nextButton = null;
        this.handlePrevClick = null;
        this.handleNextClick = null;
    }

    connectedCallback() {
        this.$section = $(this);

        // Load Swiper library if not already loaded
        if (!window.Swiper) {
            if (window.loadSwiper) {
                window.loadSwiper(() => {
                    this.initSwiper();
                });
                return;
            } else {
                this._checkSwiperInterval = setInterval(() => {
                    if (window.Swiper) {
                        clearInterval(this._checkSwiperInterval);
                        this._checkSwiperInterval = null;
                        this.initSwiper();
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(this._checkSwiperInterval);
                    this._checkSwiperInterval = null;
                }, 5000);
                return;
            }
        }

        this.initSwiper();
    }

    initSwiper() {
        // Initialize Swiper - Optimized for image carousel
        this.swiper = new Swiper(this.$section.find(".swiper-container")[0], {
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: this.$section.find(".swiper-pagination")[0],
                clickable: false
            },
            navigation: {
                nextEl: this.$section.find(".swiper-button-next")[0],
                prevEl: this.$section.find(".swiper-button-prev")[0]
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                769: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                }
            }
        });

        this.setupSwiperEvents();
        this.setupCustomNavigation();
    }

    setupSwiperEvents() {
        // Slide change event
        this.swiper.on("slideChange", () => {
            // Can add image carousel specific logic here
        });

        // Autoplay progress bar
        this.swiper.on("autoplayTimeLeft", (swiper, time, progress) => {
            const pagination = this.$section.find(".swiper-pagination")[0];
            if (pagination) {
                pagination.style.setProperty("--swiper-progress", `${(1 - progress) * 100}%`);
            }
        });

        // Window resize event
        this.resizeHandler = () => {
            if (this.swiper) {
                this.swiper.update();
            }
        };
        
        window.addEventListener("resize", this.resizeHandler);
    }

    setupCustomNavigation() {
        this.prevButton = this.querySelector(".swiper-button-prev-image");
        this.nextButton = this.querySelector(".swiper-button-next-image");

        this.handlePrevClick = () => {
            if (this.swiper) {
                this.swiper.slidePrev();
            }
        };

        this.handleNextClick = () => {
            if (this.swiper) {
                this.swiper.slideNext();
            }
        };

        if (this.prevButton) {
            this.prevButton.addEventListener("click", this.handlePrevClick);
        }

        if (this.nextButton) {
            this.nextButton.addEventListener("click", this.handleNextClick);
        }
    }

    disconnectedCallback() {
        if (this._checkSwiperInterval) {
            clearInterval(this._checkSwiperInterval);
            this._checkSwiperInterval = null;
        }
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }
        if (this.resizeHandler) {
            window.removeEventListener("resize", this.resizeHandler);
        }
        if (this.prevButton && this.handlePrevClick) {
            this.prevButton.removeEventListener("click", this.handlePrevClick);
        }
        if (this.nextButton && this.handleNextClick) {
            this.nextButton.removeEventListener("click", this.handleNextClick);
        }
    }
  });
}
